import { toTitleCase } from '../utils'

export function pageTitleFromPath(path: string): string {
  const title = path
    .split('/')
    .slice(1)
    .map(el => {
      // orders/1 -> orders #1
      if (el.match(/\d+/)) return toTitleCase(`#${el}`)
      return toTitleCase(el)
    })
    .join(' - ')

  return title || 'Lister'
}
